import * as React from "react";

import { AvatarModal } from "Components/Shared/AvatarModal";
import { LaurelWreathIcon } from "Components/Shared/Icons/LaurelWreathIcon";
import styled from "styled-components";

type Props = {
  firstName: string;
  lastName: string;
  imgUrl?: string | null;
  isTheBoss?: boolean;
  size?: string;
  fontSize?: string;
  isEnabledModal?: boolean;
  openAvatarModal?: boolean;
  setOpenAvatarModal?: (value: boolean) => void;
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
};

type StyledAvatarType = {
  size: string;
  fontSize: string;
  imgUrl: string;
  imageAvailable: boolean;
};

const StyledAvatar = styled.div<StyledAvatarType>`
  width: ${props => props.size};
  height: ${props => props.size};
  margin-right: ${props => props.theme.spacing(2)}px;
  position: relative;
  z-index: 1;

  &.click-disabled {
    pointer-events: none;
  }

  svg {
    position: absolute;
    left: -10px;
    top: -9px;
    z-index: -1;
    width: 56px;
    height: 50px;
  }

  div {
    width: ${props => props.size};
    height: ${props => props.size};
    border-radius: 50%;
    background-color: ${props =>
      props.imageAvailable
        ? "transparent"
        : props.theme.palette.secondary.dark};
    background-image: url("${props => props.imgUrl}");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: ${props => props.fontSize};
    user-select: none;
  }
`;

export const EmployeeAvatar: React.FunctionComponent<Props> = props => {
  const {
    firstName,
    lastName,
    isTheBoss,
    fontSize,
    size,
    imgUrl,
    isEnabledModal,
    openAvatarModal,
    setOpenAvatarModal,
    onClick,
  } = props;

  const [imgAvailable, setImgAvailable] = React.useState(false);

  React.useEffect(() => {
    const img = new Image();
    if (imgUrl) {
      img.onload = () => setImgAvailable(true);
      img.onerror = () => setImgAvailable(false);
      img.src = imgUrl;
    }
    return () => {
      setImgAvailable(false);
      img.onload = null;
      img.onerror = null;
    };
  }, [imgUrl]);

  const handleClose = () => {
    setOpenAvatarModal && setOpenAvatarModal(false);
  };

  return (
    <>
      <StyledAvatar
        size={size ?? "36px"}
        fontSize={fontSize ?? "17px"}
        imgUrl={imgUrl ?? ""}
        imageAvailable={imgAvailable}
        className={`avatar ${
          isEnabledModal && imgAvailable ? "" : "click-disabled"
        }`}
        onClick={onClick}
      >
        {isTheBoss && <LaurelWreathIcon />}
        <div>{imgAvailable ? "" : `${firstName[0]}${lastName[0]}`}</div>
      </StyledAvatar>
      {isEnabledModal && imgAvailable && (
        <AvatarModal
          open={openAvatarModal || false}
          onClose={handleClose}
          imageUrl={imgUrl ?? ""}
          alt={`${firstName[0]}${lastName[0]}`}
        />
      )}
    </>
  );
};
